import { notifyAuthSessionChanged } from 'src/auth/sessionEvents';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// @mui
import {
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Checkbox,
  Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { Formik, Form, Field, useFormik } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// components
import Swal from 'sweetalert2';
import { postJwtLogin } from '../../helper/backend_helper';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
    password: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .required('Password is required')
  });

  // const handleLogin = async (values) => {
  //   try {
  //     setLoading(true);
  //     // const response = await postJwtLogin(values);
  //     // localStorage.setItem('moodlift', JSON.stringify(response.data.data));
  //     localStorage.setItem('moodlift');
  //     setLoading(false);
  //     navigate('/dashboard', { replace: true });
  //     window.location.reload();
  //   } catch (error) {
  //     setLoading(false);
  //     if (error?.response?.status >= 400 || error?.response?.status < 500) {
  //       if (typeof value === 'string') {
  //         Swal.fire({
  //           position: 'center',
  //           icon: 'error',
  //           title: error.response.data.message,
  //           showConfirmButton: false,
  //           timer: 1500,
  //         });
  //       }

  //       Swal.fire({
  //         position: 'center',
  //         icon: 'error',
  //         title: error.response.data.message[0],
  //         showConfirmButton: false,
  //         timer: 1500,
  //       });
  //     }
  //   }
  // };

  const handleLogin = async (values) => {
    try {
      setLoading(true);
      const headers = {
        headers: {
          'content-type': 'application/json'
        }
      };

      const response = await postJwtLogin(values, headers);
      if (response.data.data.user.Role.name == 'USER') {
        setLoading(false);

        return toast.error(
          'You have entered an invalid email address or password',
          {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light'
          }
        );
      }

      const sessionData = response.data.data;
      const { refreshToken, ...accessSessionData } = sessionData;
      localStorage.setItem('PLS', JSON.stringify(accessSessionData));
      notifyAuthSessionChanged();
      if (refreshToken) {
        localStorage.setItem('PLS_refresh', refreshToken);
      }
      try {
        Object.keys(sessionStorage)
          .filter((key) => key.startsWith('avwf:company-dashboard-scope:v1:'))
          .forEach((key) => sessionStorage.removeItem(key));
      } catch {
        // Dashboard preferences are optional when browser storage is blocked.
      }
      navigate('/', { replace: true });
      window.location.reload();
    } catch (err) {
      console.log(err);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: err?.response?.data?.message,
        showConfirmButton: false,
        timer: 1500
      });
      setLoading(false);
    }
  };

  // setLoading(true);
  // localStorage.setItem('moodlift', JSON.stringify(values));
  // setLoading(false);
  //     navigate('/dashboard', { replace: true });
  //          window.location.reload();

  const formik = useFormik({
    initialValues: {
      password: '',
      email: ''
    },
    validationSchema,
    onSubmit: (values) => handleLogin(values)
  });

  return (
    <div className="max-w-2xl mx-auto   p-3">
      {' '}
      <div className="text-center pb-8">
        <div className="text-2xl font-semibold text-foreground">Sign In</div>
        <div className="text-muted-foreground">
          Welcome back to Av Work Force
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <Stack spacing={3}>
          <TextField
            size="small"
            label="Email address"
            InputLabelProps={{ shrink: true }}
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && !!formik.errors.email}
            helperText={formik.touched.email && formik.errors.email}
          />

          <TextField
            size="small"
            name="password"
            label="Password"
            InputLabelProps={{ shrink: true }}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOutlinedIcon />
                    ) : (
                      <VisibilityOffOutlinedIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              )
            }}
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && !!formik.errors.password}
            helperText={formik.touched.password && formik.errors.password}
          />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ my: 1 }}
        />

        <Link to="/forgot-password">
          <Typography
            variant="body2"
            // color="text.primary"
            justifySelf="flex-end"
            mb={2}
          >
            Forgot Password ?
          </Typography>
        </Link>

        {/* <LoadingButton
          fullWidth
          size="medium"
          type="submit"
          variant="contained"
          onClick={() => handleLogin}
          loading={loading}
          sx={{
            backgroundColor: '#000000',
            color: '#E8BF21',
            '&:hover': {
              backgroundColor: '#000000',
              color: '#E8BF21'
            }
          }}
        >
          Login
        </LoadingButton> */}

        <button
          type="submit"
          className="w-full h-12 bg-gradient-to-b from-[#000000] to-[#E8BF21] text-white rounded-lg hover:opacity-90 transition-all duration-200 font-medium"
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Login'}
        </button>
        <Stack alignItems="center" spacing={0.5} sx={{ mt: 2.5 }}>
          <Typography variant="body2" color="text.secondary">
            New To AVWorkforce?
          </Typography>
          <Link to="/company-application">
            <Typography variant="body2" fontWeight={700} color="primary">
              Apply For A Company Workspace
            </Typography>
          </Link>
        </Stack>
      </form>
    </div>
  );
}
